import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettings } from '../config/app-settings';

export interface LoginStatsResponse {
  general_stats: {
    total_logins: number;
    successful_logins: number;
    failed_logins: number;
    blocked_logins: number;
    email_logins: number;
    microsoft_logins: number;
    unique_users: number;
    unique_ips: number;
  };
  top_countries: any[];
  logins_by_day: { date: string; count: number }[];
  period_days: string;
}

export interface LoginLog {
  id: number;
  user_id: number;
  ip_address: string;
  user_agent: string;
  login_method: string;
  status: string;
  browser: string;
  platform: string;
  device: string;
  country: string | null;
  city: string | null;
  metadata: any[];
  logged_in_at: string;
  logged_out_at: string | null;
  created_at: string;
  updated_at: string;
  user?: { id: number; name: string; email: string };
}

export interface LoginLogsResponse {
  data: LoginLog[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export interface RecentLoginsResponse {
  recent_logins: LoginLog[];
}

@Injectable({ providedIn: 'root' })
export class UserLoginStatsService {
  constructor(private http: HttpClient) {}

  private createHeaders(): { headers: HttpHeaders } {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
      }),
    };
  }

  getLoginStats(days: number = 30): Observable<LoginStatsResponse> {
    return this.http.get<LoginStatsResponse>(
      `${AppSettings.API_URI}/admin/login-stats`,
      {
        params: new HttpParams().set('days', days.toString()),
        ...this.createHeaders(),
      }
    );
  }

  getLoginLogs(limit: number = 50, page: number = 1, status: string = 'success', method: string = 'email', user_id?: string, days?: number): Observable<LoginLogsResponse> {
    let params = new HttpParams()
      .set('limit', limit.toString())
      .set('page', page.toString())
      .set('status', status)
      .set('method', method);
    if (user_id) {
      params = params.set('user_id', user_id);
    }
    if (days) {
      params = params.set('days', days.toString());
    }
    return this.http.get<LoginLogsResponse>(
      `${AppSettings.API_URI}/admin/login-logs`,
      {
        params,
        ...this.createHeaders(),
      }
    );
  }

  getRecentLogins(limit: number = 5): Observable<RecentLoginsResponse> {
    return this.http.get<RecentLoginsResponse>(
      `${AppSettings.API_URI}/user/recent-logins`,
      {
        params: new HttpParams().set('limit', limit.toString()),
        ...this.createHeaders(),
      }
    );
  }
}
